<template>
  <span>
    <v-btn
      fab
      small
      depressed
      :color="active ? 'primary' : 'secondary'"
      class="ml-3"
      :disabled="disabled"
      @click="toggle()"
    >
      <v-icon v-text="icons.list" />
    </v-btn>
    <h-confirm
      v-model="confirm"
      :title="__('applyDiscountToEachLine')"
      :text="__('applyDiscountToEachLineDesc')"
      @yes="confirmed()"
      @no="confirm = false"
    />
    <h-pay-per-items-dialog
      v-if="render"
      v-model="dialog"
    />
  </span>
</template>

<script>
  import I18n from '@/Mixins/I18n'
  import UsesIcons from '@/Mixins/UsesIcons'
  import HAlert from '@/Components/Messages/Alert'
  import HConfirm from '@/Components/Messages/Confirm'
  import HPayPerItemsDialog from './PayPerItemsDialog'

  export default {
    mixins: [
      I18n,
      UsesIcons,
    ],

    components: {
      HAlert,
      HConfirm,
      HPayPerItemsDialog,
    },

    data: () => ({
      confirm: false,
      render: false,
      dialog: false,
    }),

    computed: {
      order () {
        return this.$store.state.orders.current
      },
      active () {
        return this.$store.getters['orders/payment/payingPerItems']
      },
      disabled () {
        return ! this.$store.getters['orders/payment/standard'] && ! this.active
      },
      hasOrderDiscount () {
        return this.order.discount !== null
      },
      hasIndividualDiscount () {
        return this.order.orderContents.some(o => o.discount !== null)
      },
    },

    watch: {
      dialog (v) {
        setTimeout(() => this.render = v, v ? 0 : 200)
      },
    },

    methods: {
      toggle () {
        this.active
          ? this.off()
          : this.hasOrderDiscount
            ? this.check()
            : this.on()
      },
      check () {
        // copied from Xef's GSApplyGeneralDiscountToEachLine.m
        if (this.hasIndividualDiscount) {
          this.$store.dispatch('alert/showError', this.__('thereIsAContentDiscount'))
          return
        }
        if (! this.order.discount.isPercentage) {
          this.$store.dispatch('alert/showError', this.__('nonPercentageDiscount'))
          return
        }
        this.confirm = true
      },
      confirmed () {
        this.confirm = false
        this.$store.commit('orders/applyOrderDiscountToContents')
        setTimeout(() => this.on(), 175)
      },
      on () {
        this.$store.dispatch('orders/payment/payPerItems/moveMenuSupplementsToStandardContents')
          .then(() => {
            this.$store.commit('orders/payment/payingPerItems')
            this.dialog = true
          })
      },
      off () {
        this.$store.dispatch('orders/payment/reset')
        this.dialog = false
      },
    },
  }
</script>
